import Head from 'next/head'

import { noLayoutConfig } from '../../components/layouts/NoLayout'
import { MagnoliaPage } from '../../components/pages/MagnoliaApp'
import { slideItems } from '../../components/pages/mobile-app/constants'
import MobileAppPage from '../../components/pages/mobile-app/MobileAppPage'

const title = 'The FIGS APP'
const description =
  'Shop 100% Awesome scrubs on the go and unlock exclusive features on our new iOS app.'
const image = 'https://cdn.shopify.com/s/files/1/0139/8942/files/frame_1.png?v=1664494391'

const MobileApp: MagnoliaPage<{}> = () => (
  <>
    <Head>
      <title key='title-tag'>{title}</title>
      <meta property='og:title' content={title} key='og:title' />
      <meta property='og:description' content={description} key='og:description' />
      <meta property='og:image' content={image} key='og:image' />
    </Head>

    <MobileAppPage
      title={title}
      description={description}
      qrCode='https://cdn.shopify.com/s/files/1/0139/8942/files/image_181.png?v=1662479823'
      qrTitle='Scan the QR code with your mobile phone to download the app'
      slideItems={slideItems}
    />
  </>
)

MobileApp.layoutConfig = noLayoutConfig

export default MobileApp
